"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("styled-components"),r=require("react"),t=require("prop-types"),o=require("@vds-core/utilities"),i=require("@vds-core/typography"),a=require("./InputText.js");function n(e){return e&&e.__esModule?e:{default:e}}var l=n(e),u=n(r),s=n(t);const f={errorText:s.default.string,errorMarginLeft:s.default.string},p={errorMarginLeft:o.calculateRem(-1)},c=l.default.div.withConfig({displayName:"StyleCheckboxError",componentId:"VDS__sc-zzfemp-0"})`
  position: relative;
  margin-top: 0;
  left: ${({errorMarginLeft:e})=>e};
`,d=e=>{const{errorText:r,color:t,errorMarginLeft:o}=e;return u.default.createElement(c,{errorMarginLeft:o},u.default.createElement(a.default,{color:t,fontFamily:i.Fonts.VerizonNHGeTX},r))};d.propTypes=f,d.defaultProps=p,exports.default=d;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/checkboxes/cjs/components/CheckboxError.js
// module id = 902
// module chunks = 0